import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { adminAPI } from "../API/API";
import { tableWaitAC } from "./error-wait-reducer";
import { HandleError } from "../utils/errors";
import { successAC } from "./error-wait-reducer";

export type TariffType = {
  _id: string;
  type: string;
  key: string;
  name: string;
  description: string;
  longDescription?: string;
  price: number;
  oldPrice: number | null;
  link?: string;
  order: number;
  active: boolean;
};

export type TariffsStateType = {
  data: TariffType[];
};

const initialState: TariffsStateType = {
  data: [],
};

const slice = createSlice({
  name: "tariffs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTariffs.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(updateTariff.fulfilled, (state, action) => {
      const idx = state.data.findIndex((t) => t._id === action.payload.data._id);
      if (idx !== -1) {
        state.data[idx] = action.payload.data;
      }
    });
  },
});
export const tariffsReducer = slice.reducer;

export const getTariffs = createAsyncThunk(
  "tariffs/get",
  async (_: void, { dispatch, rejectWithValue }) => {
    try {
      let res = await adminAPI.getTariffs();
      return {
        data: res.data.data,
      };
    } catch (e) {
      HandleError(e, dispatch);
      return rejectWithValue(null);
    }
  }
);

export const updateTariff = createAsyncThunk(
  "tariffs/update",
  async (
    param: { id: string; name?: string; description?: string; longDescription?: string; price?: number; oldPrice?: number | null; link?: string; active?: boolean },
    { dispatch, rejectWithValue }
  ) => {
    try {
      let res = await adminAPI.updateTariff(param);
      dispatch(successAC({ success: "Тариф успешно обновлен" }));
      return {
        data: res.data.data,
      };
    } catch (e) {
      HandleError(e, dispatch);
      return rejectWithValue(null);
    }
  }
);
